import { motion } from "framer-motion";
import React from "react";

function Linkedin() {
  return (
    <>
      <motion.svg
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 1.1 }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#6C27B3"
        />
        <path
          d="M17.5647 6.23072C16.1309 6.41222 14.636 6.40589 13.1315 6.26264C11.0304 6.10102 7.95976 5.13132 6.82843 7.07072C5.01099 10.1755 5.90738 14.1505 6.3309 17.6681L12.6467 23.9825C18.7586 23.658 23.657 18.7603 23.9825 12.6487L17.5647 6.23072Z"
          fill="#501A96"
        />
        <path
          d="M9.02599 9.18223H6.41622C6.30039 9.18223 6.20654 9.27612 6.20654 9.39191V17.776C6.20654 17.8918 6.30039 17.9856 6.41622 17.9856H9.02599C9.14182 17.9856 9.23567 17.8918 9.23567 17.776V9.39191C9.23567 9.27612 9.14182 9.18223 9.02599 9.18223Z"
          fill="#F8ECF8"
        />
        <path
          d="M7.72212 5.0143C6.77254 5.0143 6 5.786 6 6.73454C6 7.6835 6.77254 8.45549 7.72212 8.45549C8.67095 8.45549 9.44286 7.68345 9.44286 6.73454C9.4429 5.786 8.67095 5.0143 7.72212 5.0143Z"
          fill="#F8ECF8"
        />
        <path
          d="M15.6643 8.97385C14.6161 8.97385 13.8413 9.42445 13.3713 9.93644V9.39191C13.3713 9.27612 13.2775 9.18223 13.1616 9.18223H10.6623C10.5465 9.18223 10.4526 9.27612 10.4526 9.39191V17.776C10.4526 17.8918 10.5465 17.9857 10.6623 17.9857H13.2664C13.3822 17.9857 13.4761 17.8918 13.4761 17.776V13.6278C13.4761 12.23 13.8557 11.6854 14.8302 11.6854C15.8914 11.6854 15.9757 12.5584 15.9757 13.6997V17.776C15.9757 17.8918 16.0696 17.9857 16.1854 17.9857H18.7904C18.9062 17.9857 19.0001 17.8918 19.0001 17.776V13.1772C19.0001 11.0987 18.6038 8.97385 15.6643 8.97385Z"
          fill="#F8ECF8"
        />
      </motion.svg>
    </>
  );
}

export { Linkedin };
